"use client"

import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"

const SearchBox = ({ value, onChange, onSubmit, placeholder = "검색어를 입력하세요" }) => {
  return (
    <>
      <PC>
        <form className="search-box" onSubmit={onSubmit}>
          <input type="text" placeholder={placeholder} value={value} onChange={onChange} style={{ width: "250px" }} />
          <button type="submit">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </PC>

      <Notebook>
        <form className="search-box" onSubmit={onSubmit}>
          <input type="text" placeholder={placeholder} value={value} onChange={onChange} style={{ width: "220px" }} />
          <button type="submit">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </Notebook>

      <Tablet>
        <form className="search-box" onSubmit={onSubmit} style={{ maxWidth: "100%" }}>
          <input type="text" placeholder={placeholder} value={value} onChange={onChange} style={{ width: "180px" }} />
          <button type="submit">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </Tablet>

      <Mobile>
        <form className="search-box" onSubmit={onSubmit} style={{ width: "100%" }}>
          <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{ width: "calc(100% - 50px)" }}
          />
          <button type="submit">
            <i className="fas fa-search"></i>
          </button>
        </form>
      </Mobile>
    </>
  )
}

export default SearchBox
